import { css } from 'linaria';

export const layoutStyles = css`
  @media (--to-desktop) {
    width: 100%;
    max-width: 100vw;
  }

  @media (--from-largeDesktop) {
    max-width: var(--layout-width);
  }
`;

export const pageContentStyles = css`
  display: inline-block;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  padding: var(--space-200);
  max-width: 100%;

  @media (--to-tablet) {
    padding-right: 0;
  }

  @media (--to-desktop) {
    width: 100vw;
    max-width: none;
    padding: var(--space-200) 0;
    border-radius: initial;
  }
`;

export const pageContentStylesSponsored = css`
  display: inline-block;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  padding: var(--space-200) 0 var(--space-300) var(--space-200);
  max-width: 100%;

  @media (--to-tablet) {
    padding-right: 0;
  }

  @media (--only-mobile) {
    width: 100vw;
    max-width: none;
    padding: var(--space-200) 0;
    border-radius: initial;
  }
`;

export const topLineStyles = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  padding-right: var(--space-200);

  @media (--only-mobile) {
    margin-bottom: var(--space-200);
  }

  @media (--from-tablet) {
    margin-bottom: var(--space-225);
  }
`;

export const brandShelfTopLineStyles = css`
  width: 100%;
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const sponsoredTitleStyle = css`
  && {
    font-family:
      'LMTitle',
      'LMMain',
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      sans-serif;
    text-transform: uppercase;
  }
`;

export const brandShelfTitleStyle = css`
  color: var(--text-primary);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 21px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 26px !important;
  letter-spacing: 0.25px;
`;

export const brandShelfSubtitleStyle = css`
  color: var(--text-secondary);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 15px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.2px;
  margin-bottom: 16px !important;
`;

export const brandShelfWrapper = css`
  gap: 20px;

  @media (--from-desktop) {
    padding-left: unset;
  }

  @media (--only-mobile) {
    gap: 16px;
  }

  @media (--only-tablet) {
    gap: 24px;
  }

  @media (--only-desktop) {
    gap: 38px;
  }
`;

export const carouselItemStyles = css`
  --item-width: 163px;

  position: relative;
  min-width: var(--item-width);
  width: var(--item-width);
`;

export const seeMoreCarouselItem = css`
  margin-right: 0;
`;
